import React from 'react';
import { Icon } from 'antd';

export const CashReturnIcon = props => (<div title="Cash Return"><Icon type="dollar"/><Icon type="arrow-right" /></div>);
export const CashPickupIcon = props => (<div title="Cash Pickup"><Icon type="arrow-left" /><Icon type="dollar"/></div>);